import { ILayoutLang, LayoutLang } from "@core/services/Layout/enums/layout-config";

/**
 * @description Array of supported languages for the SADIN Frontend Framework.
 * This constant defines all available language options that can be used
 * throughout the application for internationalization purposes.
 */
export const Langs: ILayoutLang[] = [
    /**
     * @description Arabic language support with RTL (Right-to-Left) text direction
     */
    LayoutLang.Ar,
    
    /**
     * @description English language support with LTR (Left-to-Right) text direction
     */
    LayoutLang.En
];